<template>
	<div class="acoj-render">
		<div class="header-wrap" v-if="problemInfo">{{ problemInfo.problem.problem_id }}.&nbsp;{{ problemInfo.problem.title }}</div>
		<div class="main-con">
			<div class="side-wrap">
				<el-tabs v-model="activeName">
					<el-tab-pane name="1">
						<span slot="label"><i class="iconfont icon-subject"></i>&nbsp;题目详情</span>
						<div class="subject-con" ref="subjectTabs" v-if="problemInfo">
							<div class="subject-title latex-format" v-html="problemInfo.problem.description"></div>
							<div class="subject-item">
								<p><b>输入格式：</b></p>
								<pre class="latex-format" v-html="problemInfo.problem.input"></pre>
							</div>
							<div class="subject-item">
								<p><b>输出格式：</b></p>
								<pre class="latex-format" v-html="problemInfo.problem.output"></pre>
							</div>
							<div class="subject-item" v-if="problemInfo.problem.hint">
								<p><b>提示：</b></p>
								<pre class="latex-format" v-html="problemInfo.problem.hint"></pre>
							</div>
							<div class="subject-item" v-if="problemInfo.problem.restrict">
								<p><b>限制：</b></p>
								<pre v-html="problemInfo.problem.restrict"></pre>
							</div>
							<div class="subject-item subject-item-sample" v-if="problemInfo.problem.sample_input">
								<p><b>样例：</b></p>
                <div><span style="padding-bottom: 10px;display: block">输入：</span><pre style="white-space: pre;overflow: auto;" v-html="problemInfo.problem.sample_input"></pre></div>
								<div><span style="padding-bottom: 10px;display: block">输出：</span><pre style="white-space: pre;overflow: auto;" v-html="problemInfo.problem.sample_output"></pre></div>
							</div>
						</div>
					</el-tab-pane>
					<el-tab-pane name="2">
						<span slot="label"><i class="iconfont icon-evaluation"></i>&nbsp;测评详情</span>
						<div class="evaluation-con" v-if="userHomeworkResult && userHomeworkResult.result">
							<div class="evaluation-item">
								<p class="title">测评状态</p>
								<div class="result" :class="setResultMap(userHomeworkResult.result.result).style">
									<div>{{ setResultMap(userHomeworkResult.result.result).text }}</div>
									<div style="margin-left: 10px;">{{ userHomeworkResult.result.sum }}</div>
								</div>
								<div class="lang">语言：<span>{{ userHomeworkResult.result.language_name }}</span></div>
								<div class="status">
									<div>用时：<span>{{ userHomeworkResult.result.time }} ms</span></div>
									<div>内存：<span>{{ userHomeworkResult.result.memory }} kb</span></div>
									<div>代码长度：<span>{{ userHomeworkResult.result.code_length }}</span></div>
								</div>
							</div>
							<div class="evaluation-item">
								<p class="title">测试数据</p>
								<el-table :data="userHomeworkResult.result.testing_point" class="evaluation-item-table" style="width: 100%">
									<el-table-column label="编号" align="center" min-width="95">
										<template slot-scope="scope">{{ scope.$index + 1 }}</template>
									</el-table-column>
									<el-table-column label="结果" align="center" min-width="120">
										<template slot-scope="scope">
											<div :class="setResultMap(scope.row.flag).style">
												{{ acojResultMap(scope.row.flag) }}
											</div>
										</template>
									</el-table-column>
<!--									<el-table-column label="对比" align="center" min-width="180">-->
<!--										<template slot-scope="scope">-->
<!--											<div v-if="scope.row.score !== 0" class="green">AC</div>-->
<!--											<div v-else>-->
<!--												<div v-if="scope.row.ac && scope.row.diff">-->
<!--													<el-button size="mini" @click="openDialog(scope.$index)">查看-->
<!--													</el-button>-->
<!--&lt;!&ndash;													<el-button size="mini">下载</el-button>&ndash;&gt;-->
<!--												</div>-->
<!--												<div v-else class="text-secondary">暂无数据</div>-->
<!--											</div>-->
<!--										</template>-->
<!--									</el-table-column>-->
									<el-table-column prop="score" label="得分" align="center" min-width="100" />
									<el-table-column prop="usedtime" label="耗时(ms)" align="center" min-width="100" />
									<el-table-column label="下载" align="center" min-width="125">
										<template slot-scope="scope">
											<div v-if="scope.row.score === 0">
                        <el-button size="mini" :style="{backgroundColor:scope.row.allowDownload?'#27A364':'#909399!important'}" :disabled="scope.row.allowDownload !== true" @click="downloadTestPointCountAct(scope.row,scope.$index)">下载</el-button>
											</div>
											<div v-else class="green">AC 不提供下载</div>
										</template>
									</el-table-column>
								</el-table>
							</div>
							<div class="evaluation-item" v-if="userHomeworkResult.result.runtimeinfo">
								<p class="title">编译信息</p>
								<pre style="white-space: pre;overflow: auto">{{ userHomeworkResult.result.runtimeinfo }}</pre>
							</div>
						</div>
						<div class="no-data-wrap" v-else>暂无数据</div>
						<el-dialog :title="dialog.title" :visible.sync="dialog.visible" append-to-body left>
							<div class="dialog-content contrast-wrap">
								<div class="dialog-content__left dialog-content-item">
									<el-tabs type="border-card">
										<el-tab-pane label="预期">
											<pre>{{ dialog.ac }}</pre>
										</el-tab-pane>
									</el-tabs>
								</div>
								<div class="dialog-content__right dialog-content-item">
									<el-tabs type="border-card">
										<el-tab-pane label="实际">
											<pre>{{ dialog.diff }}</pre>
										</el-tab-pane>
									</el-tabs>
								</div>
							</div>
						</el-dialog>
					</el-tab-pane>
				</el-tabs>
			</div>
			<div class="editor-wrap">
				<div class="editor-top">
					<div>
            <el-select v-model="studentAnswer.langType" class="lang-select" size="small"
                       @change="changeLang">
              <el-option v-for="(option, index) in studentLang" :key="index" :label="option.lang"
                         :value="option.value" />
            </el-select>
            <div style="display: inline-block;font-size: .6rem;margin-left: 0.6rem">切换语言将不会保存代码</div>
          </div>
					<el-button type="success" style="font-size: 1rem" size="small" @click="submitCode">提交</el-button>
				</div>
				<div class="editor-bg">
					<ul class="code-edit">
						<li @click="zoom('plus')"><i class="iconfont icon-enlarge"></i></li>
						<li @click="zoom()"><i class="iconfont icon-narrow"></i></li>
						<li @click="formatCodeAction"  v-if="lang === 'c_cpp'">格式化代码</li>
					</ul>
					<div class="editor-scroll">
						<div class="editor-con" :style="{ fontSize: ACEEditorFontSize + 'px' }" :id="elementId"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {formatCode} from "@/api/homework";
import {downloadTestPoint, downloadTestPointCount} from "@/api/xinAoTraining";

	// 常量定义
	const ACOJ_RESULT_MAP = ['', '', '', '', 'AC', 'PE', 'WA', 'TLE', 'MLE', 'OLE', 'RE', 'CE', '', '', '']
	const resultMap = [{
			'style': 'gray',
			'text': '等待'
		},
		{
			'style': 'gray',
			'text': '等待重判'
		},
		{
			'style': 'orange',
			'text': '编译中'
		},
		{
			'style': 'orange',
			'text': '运行并评判'
		},
		{
			'style': 'green',
			'text': '正确'
		},
		{
			'style': 'red',
			'text': '格式错误'
		},
		{
			'style': 'red',
			'text': '答案错误'
		},
		{
			'style': 'red',
			'text': '时间超限'
		},
		{
			'style': 'red',
			'text': '内存超限'
		},
		{
			'style': 'red',
			'text': '输出超限'
		},
		{
			'style': 'navy',
			'text': '运行错误'
		},
		{
			'style': 'navy',
			'text': '编译错误'
		},
		{
			'style': 'navy',
			'text': '运行错误'
		},
		{
			'style': 'navy',
			'text': '编译错误'
		},
		{
			'style': 'green',
			'text': '编译成功'
		}
	]
	export default {
		name: "acojRender",
		props: {
			problemInfo: {
				type: Object,
				default: null
			},
			userHomeworkResult: {
				type: Object,
				default: null
			},
      allowCopy: {
        type: Boolean,
        default: true
      },
      problemLang: {
			  type: Number,
        default: 1
      }
		},
		components: {},
		data() {
			return {
				activeName: "1",
        studentLang: {
          // 0:{
          //     lang: 'c',
          //     value: '0'
          // },
          1:{
            lang: 'c++',
            value: '1'
          },
          // 2:{
          //     lang: 'Pascal',
          //     value: '2'
          //   },
          // 3:{
          //     lang: 'java',
          //     value: '3'
          //   },
          6:{
            lang: 'python',
            value: '6'
          },
          // 12:{
          //     lang: 'python3',
          //     value: '12'
          //   }
        },
				studentAnswer: { // 选择的语言
					code: '',
					langType: this.problemLang.toString()
				},
				elementId: 'acojEditor-' + this.randomString(8), // 编辑器ID
				editor: null, // 编辑器
				lang: 'c_cpp',
				testing_point: null,
				dialog: {
					title: '输出对比',
					visible: false,
					ac: '',
					did: ''
				},
				ACEEditorFontSize: 27, // 字体大小
			}
		},
		created() {
    },
		mounted() {
			this.$nextTick(()=>{

        this.initEditor();
        this.formatLatex();
      })
      const that = this
      document.addEventListener("keydown",this.copyTips, false)
		},
    destroyed() {
      document.removeEventListener("keydown",this.copyTips)
    },
    computed: {
			acojResultMap() {
				return (flag) => {
					return ACOJ_RESULT_MAP[flag]
				}
			},
			setResultMap() {
				return (result) => {
					return resultMap[result]
				}
			}
		},
		watch: {
			userHomeworkResult(newData) {
				if (newData && newData.result) {
					if (newData.result.testing_point) {
						this.testing_point = this.setAllowDownload(newData.result.testing_point)
					} else {
						this.testing_point = null
					}
					this.studentAnswer.langType = '' + newData.result.language
					this.editor.getSession().setValue(newData && newData.result.source.length > 0 ? newData.result.source +
						'\n' : '');
				} else {
					this.studentAnswer.langType = '1'
          let decodeCode = '#include <iostream>\n' +
              '#include <cstdio>\n' +
              'using namespace std;\n' +
              'int main()\n' +
              '{\n' +
              '    ' +
              '\n' +
              '    return 0;\n' +
              '}'
					this.editor.getSession().setValue(decodeCode);
					this.testing_point = null
				}
				this.lang = this.getLangMode(this.studentAnswer.langType)
			},
			problemInfo(val) {
        this.activeName = "1"
				// if (this.activeName != "1") this.activeName = "2";
        this.$nextTick(()=>{
          this.studentAnswer.langType = this.problemLang.toString()
          this.changeLang(this.studentAnswer.langType)
          this.formatLatex()

					this.$refs.subjectTabs.scrollTo({
						top: 0,
					});
        })
			},
      lang(val) {
        if (this.editor) {
          this.editor.getSession().setMode('ace/mode/' + val)
        }
      }
		},
		methods: {
			getLangMode: function(langType) {
        langType = langType.toString()
				switch (langType) {
					case '0':
					case '1':
						return 'c_cpp'
					case '2':
						return 'pascal'
					case '3':
						return 'java'
					case '6':
						return 'python'
				}
				return 'c_cpp'
			},
			initEditor() { // 初始化编辑器
        let decodeCode = this.initCode(this.studentAnswer.langType)
				if (this.userHomeworkResult && this.userHomeworkResult.result.source && this.userHomeworkResult.result
					.source.length > 0) {
					decodeCode = this.userHomeworkResult.result.source;
				}
				this.editor = window['ace'].edit(this.elementId)
				this.editor.setTheme('ace/theme/cobalt')
				this.editor.setOption('showInvisibles', true)
				this.editor.setOption('tabSize', 4)
				this.editor.setFontSize(27)
				this.editor.getSession().setMode('ace/mode/' + this.lang)
				this.editor.getSession().setValue(decodeCode && decodeCode.length > 0 ? decodeCode + '\n' : '')
				// document.getElementById(this.elementId).style.fontSize = '14px'
				this.editor.setOptions({
					enableBasicAutocompletion: false,
					enableLiveAutocompletion: false
				})
				this.editor.renderer.setShowGutter(true)
			},
			submitCode() { // 提交代码
				const code = this.editor.getSession().getValue()
				const data = {
					codeContent: code,
					language: this.studentAnswer.langType
				}
				this.$emit('commitResult', data);
				this.activeName = "2"
			},
			openDialog(index) {
				this.dialog.title = `输出对比 - 测试点${index}`
				const testingPoint = this.testing_point[index]
				this.dialog.ac = testingPoint.ac
				this.dialog.diff = testingPoint.diff
				this.dialog.visible = true
			},
			setAllowDownload(arr) {
				const index = arr.findIndex(ele => {
					return Number(ele.flag) === 6
				})
				if (index === -1) return arr
				arr[index].allowDownload = true // 暂时都不允许下载测试点
				return arr
			},
			zoom(type) { // 缩放编辑器字体大小
				if (type === 'plus') {
					this.ACEEditorFontSize += 1
				} else {
					if (this.ACEEditorFontSize > 12) {
						this.ACEEditorFontSize -= 1
					}
				}
			},
			formatCodeAction(){
        formatCode({ code: this.editor.getValue(), language: this.studentAnswer.langType }).then(res => {
          this.editor.setValue(res.data, 1)
        })
			},
			changeLang(langType) { //切换语言
        this.lang = this.getLangMode(langType)
        let decodeCode = this.initCode(langType)
        this.editor.getSession().setValue(decodeCode && decodeCode.length > 0 ? decodeCode + '\n' : '')
			},
			randomString(e) {
				e = e || 32
				const t = '12345678'
				const a = t.length
				let n = ''
				for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a))
				return n
			},
      lineBreak(data) {
        return data.replace(/\r\n|\n/g,'<br/>').replace(/\s/g,'&ensp;');
      },
      formatLatex() {
        const that = this
        const ele = ['latex-format']
        ele.forEach(function(v) {
          const katexDom = document.getElementsByClassName(v)
          for (var i = 0; i < katexDom.length; i++) {
            that.$formula(katexDom[i])
          }
        })
      },
      downloadTestPointCountAct(info, index) {
        if (this.downloading) {
          return false
        }
        this.downloading = true
        downloadTestPointCount({ testPoint: info.fname.split('.')[0], problemId: this.problemInfo.problem.problem_id, solutionId: this.userHomeworkResult.result.solution_id }).then(res => {
          if (res.status === 1) {
            this.downloadTextPointAct(info, index)
            this.$message({
              type: 'info',
              message: res.message
            })
          }
          this.downloading = false
        }).catch(()=>{
          this.downloading = false
        })
      },
      downloadTextPointAct(info, index) {
        downloadTestPoint({ testPoint: info.fname.split('.')[0], problemId: this.problemInfo.problem.problem_id, solutionId: this.userHomeworkResult.result.solution_id }).then(res => {
          const downloadName = `${this.problemInfo.problem.title}_test_point_${index}.zip`
          const blob = new Blob([res.data], { type: 'application/octet-stream' })
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, downloadName)
          } else {
            const link = document.createElement('a')
            const evt = document.createEvent('HTMLEvents')
            evt.initEvent('click', false, false)
            link.href = URL.createObjectURL(blob)
            link.download = downloadName
            link.style.display = 'none'
            document.body.appendChild(link)
            link.click()
            window.URL.revokeObjectURL(link.href)
          }
        }).catch((res) => {
        }).finally(() => {
        })
      },
      copyTips(event) {
			  const that = this
        console.log(event.which)
        if (
            (event.ctrlKey === true && event.which === 88) ||
            (event.ctrlKey === true && event.which === 67) ||
            (event.ctrlKey === true && event.which === 229) ||
            (event.metaKey === true && event.which === 88) ||
            (event.metaKey === true && event.which === 67) ||
            (event.metaKey === true && event.which === 229)
        ) {
          if(that.allowCopy !== true){
            that.$message({
              type: 'info',
              message: '禁止复制，自己写！（本次作业已截止，历史代码复制功能已禁用）'
            })
            event.preventDefault();
          }
        }
      },
      initCode(langType) {
        let decodeCode
        langType = langType.toString()
        switch (langType) {
          case '0':
          case '1':
            decodeCode = '#include <iostream>\n' +
                '#include <cstdio>\n' +
                'using namespace std;\n' +
                'int main()\n' +
                '{\n' +
                '    ' +
                '\n' +
                '    return 0;\n' +
                '}'
                break
          case '2':
          case '3':
          case '6':
            decodeCode = ''
                break
          default:
            decodeCode = '#include <iostream>\n' +
                '#include <cstdio>\n' +
                'using namespace std;\n' +
                'int main()\n' +
                '{\n' +
                '    ' +
                '\n' +
                '    return 0;\n' +
                '}'
        }
        return decodeCode
      }
		}
	}
</script>

<style lang="scss" scoped>
	.acoj-render {
		color: #FFF;
		height: 100%;

		.header-wrap {
			font-size: 22px;
			font-weight: 500;
			margin-bottom: 10px;
		}

		.main-con {
			display: flex;
			padding: 0 0 0 10px;
			font-size: 1rem;
			height: calc(100% - 39px);

			p {
				margin: 0 0 10px 0;
			}

			pre {
        margin: 0 0 10px 0;
        background: #1D4E64;
        color: #BCF3FF;
        border-radius: 6px;
        padding: 20px 20px;
        white-space: inherit;
        word-wrap: break-word;
        line-height: 2;
        font-family: Courier,Source Han Sans SC !important;
			}

			.side-wrap {
				width: 50%;
				margin-right: 20px;

				.subject-con {
					padding-right: 10px;

          .subject-title {
            padding: 0 0 20px 0;
            line-height: 2!important;
            font-size: 1rem;
            font-family: Courier,Source Han Sans SC !important;
            color: white!important;
            ::v-deep p {
              line-height: 2!important;
              font-size: 1rem!important;
              font-family: Courier,Source Han Sans SC !important;
              color: white!important;
              span {
                line-height: 2!important;
                font-size: 1rem!important;
                font-family: Courier,Source Han Sans SC !important;
                color: white!important;
              }
            }
          }

          .subject-item {
            margin-left: 10px;
            line-height: 2!important;
            font-size: 1rem!important;
            font-family: Courier,Source Han Sans SC !important;
            ::v-deep b{
              color: #ffffff!important;
            }
            ::v-deep p {
              color: #BCF3FF!important;
              line-height: 2!important;
              font-size: 1rem!important;
              font-family: Courier,Source Han Sans SC !important;
              span {
                color: #BCF3FF!important;
                line-height: 2!important;
                font-size: 1rem!important;
                font-family: Courier,Source Han Sans SC !important;
              }
            }
          }
				}

        .subject-item-sample{
          line-height: normal!important;
          ::v-deep pre {
            line-height: normal!important;
          }
          ::v-deep p {
            line-height: normal!important;
            span {
              line-height: normal!important;
            }
          }
        }

				.no-data-wrap {
					text-align: center;
					font-size: 18px;
					margin-top: 30px;
				}

				.evaluation-con {
					padding-right: 10px;

					.evaluation-item {
						margin-bottom: 20px;
						padding-left: 20px;
            .evaluation-item-table{
              border-radius: 5px;
              background:transparent;
              ::v-deep tr{
                background:transparent;
              }
              ::v-deep th.el-table__cell{
                background-color: rgba(0, 0, 0, 0);
              }
              ::v-deep td.el-table__cell{
                background: rgba(201,238,255,0.15);
              }
              ::v-deep .el-table__body tr:hover>td.el-table__cell {
                background-color: rgba(0, 0, 0, 0) !important;
              }
              ::v-deep .current-row>td.el-table__cell{
                background-color: rgba(0, 0, 0, 0);
              }
              ::v-deep .el-table__expanded-cell{
                background: transparent!important;
              }
              ::v-deep pre{
                background: transparent;
                padding: 0;
              }
              ::v-deep .el-table__empty-block{
                background: rgba(201,238,255,0.15);
              }
            }
						.result {
							display: flex;
						}

						.title {
							margin-left: -10px;
						}

						.lang {
							margin-top: 8px;
						}

						.status {
							display: flex;
							justify-content: start;
							margin-top: 8px;

							div {
								margin-right: 20px;
							}
						}

						.el-table {
							.el-button {
								border: none;
								color: #FFF;
							}
						}

						::v-deep .el-table__body tr.current-row>td.el-table__cell,
						::v-deep .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
							background-color: rgba(105, 187, 196, 0.3);
						}
					}
				}

				::v-deep .el-tabs {
					height: 100%;

          .el-tabs__item.is-active{
            font-size: 1rem;
            i{
              font-size: 1rem;
            }
          }
          .el-tabs__item{
            font-size: 0.7rem;
            i{
              font-size: 0.7rem;
            }
          }
          .el-tabs__content {
            height: 100%;
            overflow: auto;

						.el-tab-pane {
							height: 100%;

							.subject-con{
								height: 100%;
								overflow: auto;
							}
						}
          }
				}
			}

			.editor-wrap {
				width: 50%;

				.editor-top {
					display: flex;
					justify-content: space-between;

					::v-deep .el-input .el-input__inner {
						background-color: #4E7086;
						color: #FFF;
						border: none;
					}
				}

				.editor-bg {
					height: 100%;
					margin-top: 5px;
					border-image-source: url(~@/assets/img/editorBg.png);
					border-image-slice: 15 18 15 18 fill;
					border-top: 15px solid;
					border-right: 18px solid;
					border-bottom: 15px solid;
					border-left: 18px solid;
					position: relative;

					.code-edit {
						position: absolute;
						display: flex;
						right: -5px;
						top: 5px;
						z-index: 999;
            font-size: 0.6rem;
						li {
							margin-right: 10px;
							border: 1px solid #FFF;
							border-radius: 4px;
							height: 18px;
							line-height: 15px;
							padding: 0 10px;
							cursor: pointer;
              background-color: #002240;
							.iconfont {
								font-size: 12px;
							}
						}

						li:hover{
							background-color: #FFF;
							color: #333;

							.iconfont{
								color: #333;
							}
						}
					}

					.editor-scroll {
						height: 100%;
						overflow: auto;

						.editor-con {
							// min-height: 480px;
							height: 100%;
						}
					}
				}
			}

			.gray {
				color: #909399;
			}

			.orange {
				color: #E6A23C;
			}

			.green {
				color: #67C23A;
			}

			.red {
				color: #F56C6C;
			}

			.navy {
				color: #409EFF;
			}
		}
	}
</style>
